<template>
	<sf-data-table
		ref="PwaApcnTable"
		paging
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		:columns="pwaApcnCols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		selection
		:customExcel="excelFunc"
		@changedPage="changedPage"
	>
		<template v-slot:actionsLeft>
			<!-- test code -->
			<!-- pwa 신청-->
			<sf-button v-if="isButton_(scrId, 'CC')" line icon="file" :onClick="openPwaNewModal">
				{{ getMessage_('QWCC001041') }}
			</sf-button>

			<!--RO 신청현황 -->
			<sf-button v-if="isButton_(scrId, 'CC')" line icon="file" :onClick="openRoNewModal">
				{{ getMessage_('QWCC001042') }}
			</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/PwaApcn/store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
/*엑셀다운로드 시작*/
import utils from '@/utils';
import moment from 'moment';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
/*엑셀다운로드 끝*/

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			//그리드 로우
			return this.pwaApcnList;
		},
		pwaApcnCols() {
			//그리드 컬럼
			return [
				{
					label: this.getMessage_('QWCC000969'), //PWN No
					prop: 'pwaNo',
					width: '200px',
					highlight: true,
					align: 'center',
					clickEvent: this.openEditModal
				},
				{
					label: this.getMessage_('QWCC000976'), //RO No
					prop: 'roNo',
					width: '200px',
					highlight: true,
					align: 'center',
					clickEvent: this.openRoNoModal
				},
				{
					label: this.getMessage_('QWCC000963'), // 처리단계
					prop: 'prcsStepNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000978'), // 처리결과
					prop: 'prcsRsltNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001538'), // 제품ID
					prop: 'pmcId',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000975'), // 원인부품번호
					prop: 'causPartNo',
					width: '200px',
					headerAlign: 'center'
				},
				{
					label: this.getMessage_('QWCC001198'), // 원인부품명
					prop: 'causPartNm',
					width: '300px',
					headerAlign: 'center'
				},
				{
					label: this.getMessage_('QWCC000970'), // 딜러점코드
					prop: 'dlrCpnyCd',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000959'), // 딜러점
					prop: 'dlrCpnyNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000960'), // 차량VIN
					prop: 'carVin',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000972'), // 주행거리
					prop: 'milg',
					width: '100px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC000979'), // 신청일자
					prop: 'aplcDd',
					width: '120px',
					align: 'center'
				},
				{
					label: this.getMessage_('MWCC000980'), // 확정일자
					prop: 'dcsnDd',
					width: '120px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000973'), // 기종
					prop: 'flclSpcNm',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001251'), //신청자
					prop: 'aplcNm',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002119'), //차량번호판 (车牌号)
					prop: 'licensePlate',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002138'), //비보증총금액 (非质保金总金额)
					prop: 'nonWarrantyFee',
					width: '130px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC002139'), //보증총금액 (保修总金额)
					prop: 'warrantyFee',
					width: '130px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC002137'), //서비스스테이션비용 (服务站费用)
					prop: 'dlrCpnyFee',
					width: '130px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001104'), //총금액 (总金额)
					prop: 'totPartCst',
					width: '130px',
					headerAlign: 'center',
					align: 'right'
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		...utils, //커스텀 엑셀다운로드시
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			let pwaStartDt, pwaEndDt;

			//날짜 값이 없으면 날짜 포멧을 할수가 없다.
			if (this.searchParams.pwaStartDt) {
				pwaStartDt = moment(this.searchParams.pwaStartDt).format('YYYYMMDD');
			} else {
				pwaStartDt = '';
			}

			if (this.searchParams.pwaEndDt) {
				pwaEndDt = moment(this.searchParams.pwaEndDt).format('YYYYMMDD');
			} else {
				pwaEndDt = '';
			}

			queryStr = objectToQuerystring({
				dlrCpnyCd: this.searchParams.dlrCpnyCd /*딜러점*/,
				carVin: this.searchParams.carVin /*차량VIN*/,
				prcStepGb: this.searchParams.prcStepGb /*처리단계*/,
				prcPwaDd: this.searchParams.prcPwaDd /*검색구분*/,
				prcRsltCd: this.searchParams.prcRsltCd /*검색구분*/,
				pmcId: this.searchParams.pmcId /*제품ID*/,
				aplcNm: this.searchParams.aplcNm /*신청자*/,
				pwaStartDt: pwaStartDt /*신청일자from*/,
				pwaEndDt: pwaEndDt /*신청일자to*/
			});

			//console.log('조회조건>>>>', queryStr);

			//console.log('엑셀컬럼>>>', this.pwaApcnCols);

			const url = `${BASE_URL}/mqy/ceqi/pwaApcn/v1/excels` + queryStr;

			const excelCols = [...this.pwaApcnCols, { label: this.getMessage_('QWCC000053'), prop: 'prtlSbc' }];
			const params = { url, columns: excelCols };
			this.xlsxDown(params).catch(error => {
				//console.log('>>>>>>', error);

				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		openEditModal(row) {
			/*pwa 상세조회*/
			//console.log('값은>>>>', row);
			const param = {
				title: this.getMessage_('QWCC001768'), //pwa 상세
				pwaNo: row.pwaNo
			};
			this.$emit('PopupOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
		},
		openPwaNewModal() {
			// pwa 신규등록
			const param = {
				title: this.getMessage_('QWCC001041'), //pwa 신청
				pwaNo: ''
			};
			this.$emit('PopupOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
		},
		async openRoNewModal() {
			/*RO신청 버튼 클릭시*/
			const selected = this.$refs.PwaApcnTable.getSelectedRows();

			//console.log('선택한값은', selected);

			if (selected.length === 0) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			if (selected.length > 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('QWCC001166'), //한건만 선택해주세요.
					message: this.getMessage_('QWCC001166') //한건만 선택해주세요.
				});
				return;
			}

			//console.log('값은 상태값>>>', selected[0].prcsRslt);
			//console.log('값은 ro >>>', selected[0].ro);

			//선택한 RO번호
			const selRoNo = convertNvl(selected[0].roNo, '');

			try {
				//RO신청시 승인된건이면서 RO번호가 없는것들만 RO를 신청할수가 있다.

				if (selected[0].prcsRslt === '10' && selRoNo === '') {
					// RO 신규등록
					const param = {
						title: this.getMessage_('QWCC001042'), // RO 신청
						pwaNo: selected[0].pwaNo
					};

					//console.log('param', param);
					let seleetedPmcId = selected[0].pmcId;
					//제품ID기준 등록된 캠페인목록 가져오기 있으면 RO신청 못하도록 처리함.
					const response = await this.chkPmcIdCampNo(seleetedPmcId);

					//console.log('response', response);

					if (response) {
						this.$sf_showMessage({
							icon: 'ok',
							message: response,
							clickFn: this.$emit('PopupRoOpen', param)
						});
					} else {
						this.$emit('PopupRoOpen', param); //상위(Content.vue)에 정의한  PopupRoOpen 실행한다.
					}
				} else {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('QWCC001186'),
						message: this.getMessage_('MWCC000110')
					}); //승인된 건을 선택해주세요. / 선택된 데이터가 없습니다.
					return;
				}
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
			}
		},
		async chkPmcIdCampNo(paramPmcId) {
			/*row */
			const response = await this.chkPmcIdCampNo_(paramPmcId);
			if (response.header.message) {
				if (response.body.result && response.body.result.cmpnNmList) {
					return this.getMessage_('QWCC001927') + ' [' + response.body.result.cmpnNmList + ']'; //'해당 PWA번호는 캠페인대상입니다.\n' + response.body.result.cmpnNmList;
				}
			}
			return '';
		},
		openRoNoModal(row) {
			const param = {
				title: this.getMessage_('QWCC001769'), //RO 상세
				roNo: row.roNo
			};

			//console.log('param', param);

			this.$emit('PopupRoOpen', param); //상위(Content.vue)에 정의한  PopupRoOpen 실행한다.
		},
		resetTable() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}

			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		save(saveRows) {
			// console.log('@@@@ saveRows:', saveRows);

			let sendData = {
				status: 1,
				data: saveRows
			};
			/* 나중에 필요할지 몰라서 주석처리함.
			saveRows.forEach(row => {
				let pushSet = {
					varId: row.varId,
					varValue: row.varValue,
					rmk: row.rmk,
					tableState: row.tableState,
					rgtId: '',
					regDt: '',
					chgId: '',
					chgDt: ''
				};
				sendData.data.push(pushSet);
			});
			*/
			//console.log('@@@@ sendData: ', sendData);
			// return

			if (sendData.data != undefined && sendData.data.length > 0) {
				this.$sf_toggleLoading(true);
				this.setVariableManagement_(sendData)
					.then(value => {
						if (value.message != undefined && value.message != null) {
							this.$sf_toast({
								type: value.code === 0 ? 'ok' : 'error',
								message: this.getMessage_(value.messageCd)
							});
						}
						this.resetTable();
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		}
	}
};
</script>

<style></style>
